import { ArrowUpRight } from "lucide-react";
import { useLang } from "@/App";
import { Reveal, ChapterHead } from "@/components/Section";

const IMAGES = [
  "https://prieure-saint-leonard.fr/api/files/prieure-saint-leonard/uploads/5782688e-e115-4246-88d6-fa8bf9d0305c.jpg",
  "https://prieure-saint-leonard.fr/api/files/prieure-saint-leonard/uploads/6e0cb8d6-d513-4ecb-b4b3-547347bf2e54.jpg",
  "https://prieure-saint-leonard.fr/photos/mont-bay-aerial.jpg",
  "https://images.unsplash.com/photo-1526399743290-f73cb4022f48?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  "https://prieure-saint-leonard.fr/photos/prieure-cross.jpg",
];

const Ventures = () => {
  const { t } = useLang();
  return (
    <section id="activites" data-testid="ventures-section" className="relative px-5 md:px-10 py-28 md:py-40 bg-parchment scroll-mt-20">
      <div className="max-w-[1600px] mx-auto">
        <div className="flex flex-col lg:flex-row lg:items-end justify-between gap-8">
          <ChapterHead kicker={t.ventures.kicker} title={t.ventures.title} testId="ventures" />
          <Reveal delay={0.15} className="max-w-md mb-14 md:mb-20">
            <p className="text-ink2 text-sm md:text-base leading-relaxed">{t.ventures.intro}</p>
          </Reveal>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-6 gap-5">
          {t.ventures.items.map((v, i) => (
            <Reveal key={v.domain} delay={i * 0.07} className={i < 2 ? "lg:col-span-3" : "lg:col-span-2"}>
              <a
                data-testid={`venture-card-${i}`}
                href={v.url}
                target="_blank"
                rel="noreferrer"
                className="group block bg-paper border border-line hover:border-bronze transition-colors h-full"
              >
                <div className="relative overflow-hidden aspect-[16/9]">
                  <img
                    src={IMAGES[i]}
                    alt={v.name}
                    loading="lazy"
                    className="w-full h-full object-cover img-lumiere group-hover:scale-[1.05] transition-all duration-[1200ms] ease-out"
                  />
                  <span className="absolute top-4 left-4 font-mono2 text-[9px] uppercase tracking-[0.25em] bg-inkdeep/80 text-paper px-3 py-1.5 backdrop-blur-sm">
                    {v.tag}
                  </span>
                </div>
                <div className="p-6 md:p-7">
                  <div className="flex items-start justify-between gap-4">
                    <h3 className="font-display text-2xl md:text-3xl text-ink group-hover:text-terra transition-colors leading-tight">{v.name}</h3>
                    <ArrowUpRight size={18} className="text-muted2 group-hover:text-terra group-hover:translate-x-1 group-hover:-translate-y-1 transition-all shrink-0 mt-1.5" />
                  </div>
                  <p className="text-sm text-ink2 leading-relaxed mt-3">{v.desc}</p>
                  <p className="font-mono2 text-[10px] uppercase tracking-[0.2em] text-bronze mt-5">
                    {t.ventures.visit} — {v.domain}
                  </p>
                </div>
              </a>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Ventures;
